module.exports = __webpack_public_path__ + "img/redirect-arrow-rounded-pointer-down-icon.6c779fc3.svg";